import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

interface UnsavedChangesDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({ open, onConfirm, onCancel }) => (
  <Dialog open={open} onClose={onCancel}>
    <DialogTitle>Unsaved Changes</DialogTitle>
    <DialogContent>
      <DialogContentText>
        You have unsaved changes. Are you sure you want to leave? Your changes will be lost.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} sx={{ color: '#64748b' }}>Stay</Button>
      <Button onClick={onConfirm} sx={{ color: '#ef4444' }}>Discard Changes</Button>
    </DialogActions>
  </Dialog>
);

export default UnsavedChangesDialog;
